import { eventStatuses } from '../constants/events';
import { getLocalStorageItem } from '../lib/api/browserStorage';
import { getEvents } from '../lib/services/backend';

export const fetchViewed = async (excludeId?: number) => {
  let viewedActions: number[] = [];
  if (
    Object.keys(localStorage).length !== 0 &&
    typeof localStorage !== 'undefined'
  ) {
    const storedViewedEvents = getLocalStorageItem('viewed-events');

    if (storedViewedEvents) {
      viewedActions = JSON.parse(storedViewedEvents) || [];
    }
  }
  const viewedList = await getEvents({
    ids: excludeId
      ? viewedActions.filter((item) => item !== excludeId).join(',')
      : viewedActions.join(','),
    limit: 8,
    is_web: true,
    status: ['archive', eventStatuses.active].join(','),
  });
  return viewedList;
};
